import { ReactNode } from "react";

import { css } from "@compiled/react";

import Form from "@atlaskit/form";
import { N700 } from "@atlaskit/theme/colors";

import { useSiteActivationContext } from "../../hooks/site-activation-context";
import { SiteNameInput as DefaultSiteNameInput } from "../common/site-name-input";

import { SitePicker as DefaultSitePicker } from "./site-picker";
import { SiteToggleButton as DefaultSiteToggleButton } from "./site-toggle-button";
import { ExistingSitesSubmitButton as DefaultSubmitButton } from "./submit-button";

export const Content = ({
    SitePicker = <DefaultSitePicker />,
    SiteNameInput = <DefaultSiteNameInput />,
    SiteToggleButton = <DefaultSiteToggleButton />,
    SubmitButton = <DefaultSubmitButton />
}: {
    SitePicker?: ReactNode;
    SiteNameInput?: ReactNode;
    SiteToggleButton?: ReactNode;
    SubmitButton?: ReactNode;
}) => {
    const { showSitePicker, activateSite, sitesWithoutCurrentProduct } =
        useSiteActivationContext();

    return (
        <Form onSubmit={activateSite} isDisabled={false}>
            {({ formProps }) => (
                <form
                    {...formProps}
                    autoComplete="off"
                    css={containerCss}
                    data-testid="existing-sites-site-activation"
                >
                    <div>
                        {showSitePicker && <>{SitePicker}</>}
                        {!showSitePicker && <>{SiteNameInput}</>}
                        {sitesWithoutCurrentProduct.length > 0 && (
                            <>{SiteToggleButton}</>
                        )}
                    </div>
                    {SubmitButton}
                </form>
            )}
        </Form>
    );
};

const containerCss = css({
    color: N700,
    display: "grid",
    gap: "24px"
});
